// extracted by mini-css-extract-plugin
module.exports = {"button":"ConnectedButtons_button__TTWpT","arrow-icon":"ConnectedButtons_arrow-icon__vi8Ol"};